import { SupportedBrowser } from './SupportedBrowser/SupportedBrowser';
import { UnsupportedBrowser } from './UnsupportedBrowser/UnsupportedBrowser';
import Video from 'twilio-video';

export function BrowserTest() {
  const isSecureBrowser = navigator.userAgent.includes('Proview-SB');
  return <>{Video.isSupported || isSecureBrowser ? <SupportedBrowser /> : <UnsupportedBrowser />}</>;
}
